import { render, staticRenderFns } from "./RouterLinkWrapper.vue?vue&type=template&id=557a801e"
import script from "./RouterLinkWrapper.vue?vue&type=script&lang=js"
export * from "./RouterLinkWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports